export default {
  presets: {
    light: {
      primary: '#1298FF',
      secondary: '#FAFAFA',
      backgroundPrimary: '#F4F7FC',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#FFFFFF',
      backgroundCardSecondary: '#F7FAFF',
      backgroundElement: '#FFFFFF',
      backgroundBorder: '#DCE4F0',
      textPrimary: '#1A1F2B',
      textInverted: '#FFFFFF',
      success: '#00A86B',
      info: '#1A79FF',
      danger: '#D64545',
      warning: '#FFB400',
      focus: '#2B8BFF',
    },
    dark: {
      primary: '#1298FF',
      backgroundPrimary: '#0F172A',
      backgroundSecondary: '#111827',
    },
  },
}
